import { render, staticRenderFns } from "./FacebookSummary.vue?vue&type=template&id=209a344c&lang=pug"
import script from "./FacebookSummary.vue?vue&type=script&lang=js"
export * from "./FacebookSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports